import * as Action from '../action';

export default (state = {}, action) => {
  switch (action.type) {
    case Action.ADD_PAYMENT_ON_BEHALF_LIST:
      return { ...action.value };
    default:
      return state;
  }
};
